import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const CheckCircleIcon = ({ className }) => (
  <span className={classnames('checkCircleIcon', className)}>
    <i className='text-color-success g72-check' />
  </span>
);

CheckCircleIcon.defaultProps = {
  className: null
};

CheckCircleIcon.propTypes = {
  className: PropTypes.string
};

export default CheckCircleIcon;
